export const digitCont = {
	hidden: { opacity: 0 },
	show: {
		opacity: 0.4,
		transition: {
			staggerChildren: 1,
		},
	},
};
